module.exports = __webpack_public_path__ + "media/images/steps/png/197-meeting-2-0f3dc7fa3257790709c0f55284a4bc69.png";